import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const Item = styled.li`
  list-style: none;
  width: ${({ $mobile }) => ($mobile ? '100%' : 'auto')};
`;

const StyledNavLink = styled(NavLink)`
  min-height: 2.65rem;
  display: inline-flex;
  align-items: center;
  justify-content: ${({ $mobile }) => ($mobile ? 'flex-start' : 'center')};
  gap: 0.48rem;
  width: ${({ $mobile }) => ($mobile ? '100%' : 'auto')};
  padding: ${({ $mobile }) => ($mobile ? '0.85rem 1rem' : '0.52rem 0.78rem')};
  border-radius: 0.86rem;
  color: ${({ $mobile }) => ($mobile ? 'rgba(255,255,255,.72)' : 'rgba(255,255,255,.7)')};
  font-size: 0.86rem;
  font-weight: 750;
  text-decoration: none;
  transition: color 160ms ease, background 160ms ease, transform 160ms ease;

  svg {
    font-size: 1.12rem;
  }

  &:hover {
    color: #fff;
    background: rgba(255,255,255,.09);
    text-decoration: none;
  }

  &.active {
    color: #111;
    background: #fff;
    box-shadow: 0 .4rem 1rem rgba(0,0,0,.16);
  }

  ${({ $mobile }) => $mobile && `
    &.active {
      color: #000;
      background: #c0a375;
      box-shadow: none;
    }
  `}
`;

function NavItem({ link, children, mobile, clicked, exact = true }) {
  return (
    <Item $mobile={mobile}>
      <StyledNavLink
        exact={exact}
        activeClassName="active"
        $mobile={mobile}
        onClick={clicked}
        to={link}
      >
        {children}
      </StyledNavLink>
    </Item>
  );
}

export default NavItem;
